import { render, staticRenderFns } from "./GridTableEmptyData.vue?vue&type=template&id=7223de63&scoped=true"
import script from "./GridTableEmptyData.vue?vue&type=script&lang=js"
export * from "./GridTableEmptyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7223de63",
  null
  
)

export default component.exports